export const categories = [
  {
    slug: 'membership',
    name: '会员权益',
    description: '了解hth会员专属权益与等级体系，享受更多平台特权',
    icon: 'ri-vip-crown-line',
    items: [
      {
        title: '青铜会员',
        description: '注册即享基础权益，正品保障，专属客服通道',
        features: ['正品保障', '专属客服', '基础折扣', '积分累计'],
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20minimalist%20interior%20scene%20with%20soft%20natural%20lighting%2C%20professional%20atmosphere%2C%20cream%20and%20golden%20accents%2C%20luxury%20lifestyle%20photography%2C%20clean%20composition%2C%20harmonious%20warm%20tones&width=800&height=500&seq=membership-bronze-2026&orientation=landscape',
        slug: 'bronze-membership',
      },
      {
        title: '白银会员',
        description: '升级白银会员，享受更多专属优惠和服务特权',
        features: ['全部青铜权益', '优先发货', '双倍积分', '生日礼遇'],
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20minimalist%20interior%20scene%20with%20soft%20natural%20lighting%2C%20professional%20atmosphere%2C%20cream%20and%20silver%20accents%2C%20luxury%20lifestyle%20photography%2C%20clean%20composition&width=800&height=500&seq=membership-silver-2026&orientation=landscape',
        slug: 'silver-membership',
      },
      {
        title: '黄金会员',
        description: '黄金会员尊享顶级服务，全场折扣与专属管家',
        features: ['全部白银权益', '全场折扣', '专属管家', '免邮特权'],
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20minimalist%20interior%20scene%20with%20soft%20natural%20lighting%2C%20professional%20atmosphere%2C%20cream%20and%20golden%20accents%2C%20luxury%20lifestyle%20photography%2C%20clean%20composition%2C%20harmonious%20warm%20tones&width=800&height=500&seq=membership-gold-2026&orientation=landscape',
        slug: 'gold-membership',
      },
      {
        title: '钻石会员',
        description: '钻石会员为您提供极致尊贵体验，一切皆有可能',
        features: ['全部黄金权益', '私人定制', '全球配送', '年度大礼'],
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20minimalist%20interior%20scene%20with%20soft%20natural%20lighting%2C%20professional%20atmosphere%2C%20cream%20and%20diamond%20accents%2C%20luxury%20lifestyle%20photography%2C%20clean%20composition&width=800&height=500&seq=membership-diamond-2026&orientation=landscape',
        slug: 'diamond-membership',
      },
    ],
  },
  {
    slug: 'news',
    name: '平台资讯',
    description: '获取hth平台最新动态、活动资讯与行业前沿信息',
    icon: 'ri-newspaper-line',
    items: [
      {
        title: 'hth 2026年度盛典即将开启',
        description: '一年一度的hth年度盛典将于8月正式启动，届时将有重磅新品发布与会员专属福利。',
        date: '2026-08-01',
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20minimalist%20event%20scene%20with%20soft%20natural%20lighting%2C%20professional%20corporate%20atmosphere%2C%20cream%20and%20golden%20accents%2C%20celebration%20theme%2C%20clean%20composition&width=800&height=500&seq=news-item-1-2026&orientation=landscape',
        slug: 'annual-gala-2026',
      },
      {
        title: 'hth 正品保障体系全面升级',
        description: '为进一步提升用户信任，hth正式发布全新的正品保障体系，从源头到交付全程可追溯。',
        date: '2026-07-28',
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20minimalist%20quality%20control%20scene%20with%20soft%20natural%20lighting%2C%20professional%20atmosphere%2C%20cream%20and%20golden%20accents%2C%20supply%20chain%20theme%2C%20clean%20composition&width=800&height=500&seq=news-item-2-2026&orientation=landscape',
        slug: 'authenticity-system-upgrade',
      },
      {
        title: 'hth 会员权益全新改版上线',
        description: '四大等级体系全面优化，新增多项会员专属服务，让每位用户都能享受更贴心的服务体验。',
        date: '2026-07-20',
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20minimalist%20membership%20scene%20with%20soft%20natural%20lighting%2C%20professional%20atmosphere%2C%20cream%20and%20golden%20accents%2C%20vip%20theme%2C%20clean%20composition&width=800&height=500&seq=news-item-3-2026&orientation=landscape',
        slug: 'membership-revamp',
      },
      {
        title: 'hth 平台用户突破千万里程碑',
        description: '感谢每一位用户的信任与支持，hth平台累计注册用户已突破千万大关。',
        date: '2026-07-15',
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20minimalist%20celebration%20scene%20with%20soft%20natural%20lighting%2C%20professional%20atmosphere%2C%20cream%20and%20golden%20accents%2C%20milestone%20theme%2C%20clean%20composition&width=800&height=500&seq=news-item-4-2026&orientation=landscape',
        slug: 'ten-million-users',
      },
      {
        title: 'hth 极速服务体系获行业认可',
        description: 'hth极速服务荣获年度最佳客户体验奖，7x24小时全天候服务深受用户好评。',
        date: '2026-07-10',
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20minimalist%20award%20ceremony%20scene%20with%20soft%20natural%20lighting%2C%20professional%20atmosphere%2C%20cream%20and%20golden%20accents%2C%20trophy%20theme%2C%20clean%20composition&width=800&height=500&seq=news-item-5-2026&orientation=landscape',
        slug: 'speed-service-award',
      },
      {
        title: 'hth 技术架构全新升级完成',
        description: '平台底层架构全面升级，系统响应速度提升300%，为用户带来更流畅的操作体验。',
        date: '2026-07-05',
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20minimalist%20technology%20scene%20with%20soft%20natural%20lighting%2C%20professional%20atmosphere%2C%20cream%20and%20golden%20accents%2C%20server%20room%20theme%2C%20clean%20composition&width=800&height=500&seq=news-item-6-2026&orientation=landscape',
        slug: 'tech-architecture-upgrade',
      },
    ],
  },
  {
    slug: 'guide',
    name: '使用指南',
    description: 'hth平台使用教程与操作指引，帮助您快速上手',
    icon: 'ri-guide-line',
    items: [
      {
        title: '新用户注册与认证指南',
        description: '三步完成hth平台注册认证，开启您的品质之旅。详细步骤图文说明。',
        date: '2026-07-25',
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20minimalist%20tutorial%20scene%20with%20soft%20natural%20lighting%2C%20professional%20atmosphere%2C%20cream%20and%20golden%20accents%2C%20registration%20theme%2C%20clean%20composition&width=800&height=500&seq=guide-item-1-2026&orientation=landscape',
        slug: 'register-guide',
      },
      {
        title: '会员权益使用全攻略',
        description: '全面了解hth会员各项权益的使用方法与注意事项，让您的会员价值最大化。',
        date: '2026-07-18',
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20minimalist%20guide%20scene%20with%20soft%20natural%20lighting%2C%20professional%20atmosphere%2C%20cream%20and%20golden%20accents%2C%20membership%20theme%2C%20clean%20composition&width=800&height=500&seq=guide-item-2-2026&orientation=landscape',
        slug: 'membership-guide',
      },
      {
        title: '平台安全操作规范',
        description: '了解hth平台的安全机制与用户操作规范，保障您的账户与交易安全。',
        date: '2026-07-12',
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20minimalist%20security%20scene%20with%20soft%20natural%20lighting%2C%20professional%20atmosphere%2C%20cream%20and%20golden%20accents%2C%20shield%20theme%2C%20clean%20composition&width=800&height=500&seq=guide-item-3-2026&orientation=landscape',
        slug: 'security-guide',
      },
      {
        title: '积分获取与兑换教程',
        description: '积分规则详解：如何高效获取积分并兑换心仪权益，一站式操作指引。',
        date: '2026-07-08',
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20minimalist%20points%20scene%20with%20soft%20natural%20lighting%2C%20professional%20atmosphere%2C%20cream%20and%20golden%20accents%2C%20rewards%20theme%2C%20clean%20composition&width=800&height=500&seq=guide-item-4-2026&orientation=landscape',
        slug: 'points-guide',
      },
    ],
  },
];